export default __webpack_public_path__ + "static/media/rnd.f1d45ad8.png";